module.exports = __webpack_public_path__ + "static/img/rank_267.9255c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_267.png
// module id = TXU1
// module chunks = 0